import { SearchOutlined } from "@ant-design/icons";
import { Input, Table } from "antd";
import "antd/dist/antd.css";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import useSWR from "swr";
import Api from "../../../../../initialpage/hooks/Api";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);

const ProjectAssetView = () => {
  const {
    data: dataSource,
    error,
    mutate,
  } = useSWR(`store/products/project/asset/view`, fetcher);
  console.log(dataSource);
  // console.log(singleData);

  const columns = [
    {
      title: "ID",
      className: "dark_bg ",
      dataIndex: "ASSET_MST_ID",
    },
    {
      title: "Supply Date",
      className: "dark_bg ",
      render: (text, record) => <td>{record.RECEIVE_DATE.split("T")[0]}</td>,
    },
    {
      title: "Project Name",
      className: "dark_bg ",
      render: (text, record) => (
        <div className="text-start">
          <td>{record.PROJECT_NAME}</td>
        </div>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type Project name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.PROJECT_NAME.toLowerCase().includes(value.toLowerCase());
      },
    },

    {
      title: "Document",
      className: "dark_bg text-center ",
      render: (text, record) => (
        <>
          {record.FILE_PATH ? (
            <a
              href={`https://${Api}/static${record.FILE_PATH}`}
              target="_blank"
              className="btn  px-3 printBtn show ms-auto  me-2 "
              style={{
                background: "#CF0A0A",
                color: "#fff",
                borderRadius: "5px",
              }}
            >
              <i className="fa fa-eye me-1"></i> File
            </a>
          ) : (
            <a
              target="_blank"
              className="btn  px-3 printBtn show ms-auto  me-2 "
              style={{
                background: "#CF0A0A",
                color: "#fff",
                borderRadius: "5px",
              }}
            >
              <i className="fa fa-eye me-1"></i> File
            </a>
          )}
        </>
      ),
    },

    {
      title: "Action",
      className: "dark_bg text-center",
      render: (text, record) => (
        <Link to={`/projectassetmanage/view/${record.ASSET_MST_ID}`}>
          <button
            className="px-3 ms-auto  me-2 "
            style={{
              backgroundColor: "#3C8DBC",
              color: "#fff",
              borderRadius: "10px",
            }}
          >
            <i className="fa fa-eye m-r-5" /> View
          </button>
        </Link>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Project Asset Product - BBA STORE</title>
        <meta name="description" content="Request Product - BBA STORE" />
      </Helmet>

      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            <h3 className="text-start text-dark">
              Manage Project Asset Product
            </h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            {!dataSource ? (
              <NotFoundPage />
            ) : (
              <div className="row ">
                <div className="col-md-12 ">
                  <div className="table-responsive">
                    <Table
                      className="table-striped"
                      pagination={false}
                      style={{ overflowX: "auto" }}
                      columns={columns}
                      // bordered
                      dataSource={dataSource === undefined ? [] : dataSource}
                      rowKey={(record) => record.ASSET_MST_ID}
                      onChange={console.log("change")}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectAssetView;
